import { InvestmentQuote } from "@rentablo/api/apiv1";

export const getDisplayedQuoteValue = (
  quote: InvestmentQuote | undefined,
  isOriginal: boolean
): number => {
  if (!quote) return 0;
  if (isOriginal) return quote.last ?? 0;
  return quote.lastInDisplayCurrency ?? 0;
};

export const getDisplayedChangeAbs = (
  quote: InvestmentQuote | undefined,
  isOriginal: boolean
): number => {
  const changeAbs = quote?.changeAbs ?? 0;
  if (isOriginal || !quote?.last || !quote.lastInDisplayCurrency) {
    return changeAbs;
  }
  return changeAbs * (quote.lastInDisplayCurrency / quote.last);
};
